import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import styles from './DayEventsModal.module.css';
import eventStyles from './RenderEventContent.module.css';
import stylesCategory from 'styles/modules/Categories.module.css';
import eventModalStyles from './EventModal.module.css';

Modal.setAppElement('#root');

const formatDayTitle = (date) => {
  if (!date) {
    return 'Événements';
  }
  return new Intl.DateTimeFormat('fr-FR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
};

const getCategoryClass = (event) => {
  const categories = event.categories || [];
  const filtered = categories.filter((cat) => cat.slug !== 'evenements');
  const category = filtered[0] || categories[0];
  return category ? stylesCategory[category.slug] : eventStyles.defaultDot;
};

const DayEventsModal = ({ isOpen, onRequestClose, date, events, onEventClick }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel={`Événements du ${formatDayTitle(date)}`}
      className={styles.modal}
      overlayClassName={eventModalStyles.overlay}
    >
      <button
        className={eventModalStyles.closeButton}
        onClick={onRequestClose}
        aria-label="Fermer la fenêtre"
      >
        <div className={eventModalStyles.lineContainer}>
          <span className={eventModalStyles.line}></span>
          <span className={eventModalStyles.line}></span>
        </div>
        Fermer
      </button>

      <h2 className={styles.title}>{formatDayTitle(date)}</h2>

      {events.length === 0 ? (
        <p>Aucun événement ce jour.</p>
      ) : (
        <ul className={styles.list}>
          {events.map((event) => (
            <li key={event.id || event.slug}>
              <button
                type="button"
                className={styles.item}
                onClick={() => onEventClick(event)}
              >
                <span className={`${eventStyles.dot} ${getCategoryClass(event)}`} />
                <span className={styles.itemTitle}>{event.title}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </Modal>
  );
};

DayEventsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  date: PropTypes.instanceOf(Date),
  events: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
      slug: PropTypes.string,
      categories: PropTypes.array,
    })
  ).isRequired,
  onEventClick: PropTypes.func.isRequired,
};

DayEventsModal.defaultProps = {
  date: null,
};

export default DayEventsModal;
